/**
 * Beschriftetes Eingabefeld und Auswahl.
 *
 * Bewusst duenn: ein Label, ein Feld, ein Fehlersatz. Die Buchhaltung hat
 * viele Felder auf wenig Flaeche (die Detailansicht eines Belegs zeigt allein
 * zwoelf) — jede zusaetzliche Verzierung waere zwoelfmal da.
 */

import { ReactNode } from 'react';
import { clsx } from 'clsx';

const FELD_KLASSEN =
  'w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 ' +
  'placeholder:text-slate-400 focus:border-primary-500 focus:outline-none focus:ring-1 ' +
  'focus:ring-primary-500 disabled:cursor-not-allowed disabled:bg-slate-50 disabled:text-slate-500';

export function Feld({
  label,
  hinweis,
  pflicht,
  children,
}: {
  label: string;
  hinweis?: string;
  pflicht?: boolean;
  children: ReactNode;
}) {
  return (
    <label className="block">
      <span className="mb-1 block text-xs font-medium text-slate-600">
        {label}
        {pflicht && <span className="ml-0.5 text-danger-600">*</span>}
      </span>
      {children}
      {hinweis && <span className="mt-1 block text-xs text-slate-400">{hinweis}</span>}
    </label>
  );
}

export function Eingabe(props: React.InputHTMLAttributes<HTMLInputElement>) {
  return <input {...props} className={clsx(FELD_KLASSEN, props.className)} />;
}

export function Auswahl(props: React.SelectHTMLAttributes<HTMLSelectElement>) {
  return <select {...props} className={clsx(FELD_KLASSEN, props.className)} />;
}

export function Textfeld(props: React.TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return <textarea {...props} className={clsx(FELD_KLASSEN, 'resize-y', props.className)} />;
}

/** Ueberschrift einer Seite, mit Platz fuer Knoepfe rechts. */
export function Seitenkopf({
  titel,
  beschreibung,
  children,
}: {
  titel: string;
  beschreibung?: string;
  children?: ReactNode;
}) {
  return (
    <div className="mb-6 flex flex-wrap items-start justify-between gap-3">
      <div>
        <h1 className="text-xl font-semibold text-slate-900">{titel}</h1>
        {beschreibung && <p className="mt-1 text-sm text-slate-500">{beschreibung}</p>}
      </div>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
}
